module.exports = __webpack_public_path__ + "img/add_circle_outline_black_24dp.bf629942.svg";